import { gql } from 'graphql-request'

const GET_ALL_PUBLISHERS = gql`
  query publishers {
    publishers {
      accountManagerId
      createdAt
      enabled
      currency
      isEligibleForTurbo
      id
      name
      updatedAt
    }
  }
`

export default GET_ALL_PUBLISHERS
